import { render, staticRenderFns } from "./LightIntensity.vue?vue&type=template&id=49097036&scoped=true&"
import script from "./LightIntensity.vue?vue&type=script&lang=ts&"
export * from "./LightIntensity.vue?vue&type=script&lang=ts&"
import style0 from "./LightIntensity.vue?vue&type=style&index=0&id=49097036&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49097036",
  null
  
)

export default component.exports